// extracted by mini-css-extract-plugin
export default {"input":"StockedItemsQtyInput_input__qkUZj","input--error":"StockedItemsQtyInput_input--error__YJp1+"};